"use client";
import React from "react";
import { Content } from "@/lib/getDocumentsAndDeliverables";
import { Typography } from "@/components/ui/typography";
import {
  FaqStackWithContentful,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

type Props = {
  content: Pick<Content, "faq">;
};

export default function DocumentFAQ({ content }: Props) {
  return (
    <section className="section">
      <div className="container mx-auto py-12 md:py-20">
        <div className="border-b border-gray-300">
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Frequently asked questions</h2>
          </Typography>

          <FaqStackWithContentful content={content} className="mt-6" />
        </div>
        <FaqLinkBlock
          title="Have more questions? Visit our FAQ page for more answers."
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
}
